







import { Component, Vue, Prop } from 'vue-property-decorator';
import DownloadWx from './components/download-wx.vue';
import { bothReport, setBiPrefix, setReportMethod } from './report';
import { isInWeixin } from '@tencent/wphk-components-common/utils/ua';

@Component({
  components: {
    DownloadWx,
  },
})
export default class CIndex extends Vue {
  /** 数据上报前缀A.B，如果没有传入则是promotion.thirdappredirect */
  @Prop() private biPrefix?: string;
  /** 数据上报方法，如果没有传入，则是香港钱包的biHottag；接受两个参数事件名(A.B.C.D)和扩展字段({key:value}) */
  @Prop() private reportMethod?: Function;
  @Prop({
    type: String,
    default: 'white',
  }) private bgColor;
  @Prop() private hideDownloadInWeixin?: boolean;

  private created() {
    setBiPrefix(this.biPrefix);
    setReportMethod(this.reportMethod);
    bothReport('container.page_brow');
  }

  get isShowDownload() {
    if (isInWeixin()) {
      return !this.hideDownloadInWeixin;
    }
    return true;
  }
}
